import { Link } from "react-router-dom";

const advantages = [
  {
    icon: "ri-layout-grid-line",
    title: "分类体系清晰",
    desc: "10 个一级分类、30+ 二级领域，常见需求都有明确归属。",
  },
  {
    icon: "ri-shield-check-line",
    title: "人工筛选维护",
    desc: "编辑逐条核对站点用途与稳定性，减少失效与钓鱼链接。",
  },
  {
    icon: "ri-device-line",
    title: "桌面移动通用",
    desc: "手机端一列卡片与加载更多，通勤路上也能顺畅浏览。",
  },
];

export default function AboutStrip() {
  return (
    <div className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-8">
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">
        <div className="lg:w-[300px] shrink-0">
          <span className="text-xs text-accent-600 tracking-wide">ABOUT US</span>
          <h2 className="mt-2 font-heading font-bold text-xl md:text-2xl text-foreground-950">
            一个更干净的网址入口
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-7">
            51网址导航面向学生、职场人士与家庭用户，把高频网站按生活、购物、娱乐、学习等场景整理好，让你三次点击内到达目标。
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <Link
              to="/about"
              className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
            </Link>
            <Link
              to="/about#feedback"
              className="px-4 py-2 rounded-md bg-background-50 border border-background-300 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              提交网址
            </Link>
          </div>
        </div>

        <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="p-4 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-lg`} />
              </span>
              <h3 className="mt-3 text-sm font-medium text-foreground-950">{item.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-5">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}